// TODO: Типы которые в дальнейшем будут приходить с бека

export enum EBenefitProgram {
  'All' = 'all',
  /** Семейная **/
  'Family' = 'family',
  /** ИТ-ипотека **/
  'It' = 'it',
  /** Без программы **/
  'NoProgram' = 'noProgram',
}

export enum EEmploymentType {
  /** Владелец бизнеса **/
  'BusinessOwner' = 'businessOwner',
  /** Полная занятость **/
  'Employee' = 'employee',
  /** ИП **/
  'Entrepreneur' = 'entrepreneur',
  /** Самозанятый **/
  'SelfEmployed' = 'selfEmployed',
}
export enum EIncomeConfirmation {
  /** С подтверждением **/
  'Confirmation' = 'confirmation',
  /** Без подтверждения **/
  'NoConfirmation' = 'noConfirmation',
}
export enum EObjectType {
  /** Апартаменты **/
  'Apartments' = 'apartments',
  /** Квартира **/
  'Flat' = 'flat',
  /** Дом **/
  'House' = 'house',
}
export enum ERealEstateType {
  /** Новостройка **/
  'NewBuilding' = 'newBuilding',
  /** Вторичка **/
  'Secondary' = 'secondary',
  /** Строительство дома **/
  'HouseBuilding' = 'houseBuilding',
}
